import { APP_INVITE_CODE_PATH, APP_INVITE_PATH, APP_OPEN_PATH } from '../router/paths';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyBUvx16d21CVCBIKVN33PUf5ajmcHygeVI',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'pexar-3d645.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'pexar-3d645',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'pexar-3d645.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '955858154528',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:955858154528:web:f741fd05a4a02378b4f845',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-WBF0DYYDTB'
};

let analyticsClientPromise;

const ANDROID_INTENT_ATTEMPTED_KEY = 'appIntentAttempted';

const hasFirebaseConfig = () => (
  Boolean(firebaseConfig.apiKey)
  && Boolean(firebaseConfig.appId)
  && Boolean(firebaseConfig.measurementId)
);

const detectPlatform = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
  const isIOS = /iPad|iPhone|iPod/.test(userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /android/i.test(userAgent);

  if (isIOS) {
    return 'ios';
  }

  if (isAndroid) {
    return 'android';
  }

  return 'desktop';
};

const normalizeDownloadPath = pathname => pathname.replace(/\/+$/, '');

export const isInviteLink = (pathname = window.location.pathname) => {
  const path = normalizeDownloadPath(pathname);
  return path === APP_INVITE_PATH || path === APP_INVITE_CODE_PATH;
};

const getDownloadEntryType = pathname => (
  isInviteLink(pathname) ? 'invite' : 'open'
);

const isDownloadPagePath = (pathname) => (
  normalizeDownloadPath(pathname) === APP_OPEN_PATH
  || isInviteLink(pathname)
);

export const getDownloadAnalyticsParams = ({
  pathname = window.location.pathname,
  search = window.location.search
} = {}) => {
  if (!isDownloadPagePath(pathname)) {
    return {};
  }

  const searchParams = new URLSearchParams(search);

  return {
    entry_type: getDownloadEntryType(pathname),
    platform: detectPlatform(),
    invite_code_present: searchParams.has('c') || searchParams.has('code'),
    app_intent_attempted: searchParams.get(ANDROID_INTENT_ATTEMPTED_KEY) === '1'
  };
};

const sanitizeEventParams = (params = {}) => (
  Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null) {
      acc[key] = value;
    }

    return acc;
  }, {})
);

const getAnalyticsClient = () => {
  if (typeof window === 'undefined' || !hasFirebaseConfig()) {
    return Promise.resolve(null);
  }

  if (!analyticsClientPromise) {
    analyticsClientPromise = Promise.all([
      import('firebase/app'),
      import('firebase/analytics')
    ])
      .then(async ([appModule, analyticsModule]) => {
        const isSupported = await analyticsModule.isSupported();

        if (!isSupported) {
          return null;
        }

        const app = appModule.getApps().length > 0
          ? appModule.getApp()
          : appModule.initializeApp(firebaseConfig);

        return {
          analytics: analyticsModule.initializeAnalytics(app),
          logEvent: analyticsModule.logEvent
        };
      })
      .catch(() => null);
  }

  return analyticsClientPromise;
};

export const trackEvent = (eventName, params = {}) => {
  getAnalyticsClient()
    .then((client) => {
      if (!client) {
        return;
      }

      client.logEvent(client.analytics, eventName, sanitizeEventParams(params));
    })
    .catch(() => {});
};

export const trackRouteView = ({ pathname, search }) => {
  trackEvent('portal_route_view', {
    page_path: pathname,
    page_location: `${window.location.origin}${pathname}${search || ''}`,
    page_title: document.title,
    ...getDownloadAnalyticsParams({ pathname, search })
  });
};
